
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Indicator from './indicator'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "indicator"
    }}>{`Indicator`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Feedback`}</p>
    <hr />
    <h2 {...{
      "id": "indicator-loading"
    }}>{`Indicator (loading)`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For indicating that a change is progress, or data are loading.`}</p>
    <Playground __position={1} __code={'<Indicator />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Indicator
    }} mdxType="Playground">
  <Indicator mdxType="Indicator" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "indicator-loading-inverse"
    }}>{`Indicator (loading, inverse)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For indicating that a change is progress, or data are loading.`}</p>
    <Playground __position={3} __code={'<Indicator inverse />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Indicator
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <Indicator inverse mdxType="Indicator" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Indicator} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;